import Reveal from "./Reveal";
import { IMAGES, SITE, whatsappLink } from "@/constants/site";

export default function FinalCTA() {
  const waLink = whatsappLink(
    "Merhaba Düzbağ Life, birkaç günlük bir kaçamak için rezervasyon yapmak istiyorum."
  );

  return (
    <section className="relative w-full h-[80vh] min-h-[560px] overflow-hidden">
      <img
        src={IMAGES.night}
        alt="Gece aydınlatılmış Düzbağ Life bungalovları"
        title="Düzbağ Life gece bungalov konaklama"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/85" />

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-8">
        <Reveal>
          <h2 className="font-heading text-background-50 text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-medium leading-[1.12] tracking-wide max-w-4xl">
            BİRKAÇ GÜNLÜĞÜNE HER ŞEYDEN
            <br />
            UZAKLAŞIN.
          </h2>
          <p className="mt-6 text-background-200 text-sm md:text-base lg:text-lg max-w-2xl mx-auto">
            Birkaç günlüğüne de olsa doğanın içinde nefes alın. Düzbağ Life'ta
            yerinizi ayırtın.
          </p>
          <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4">
            <a
              href={waLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-accent-500 hover:bg-accent-600 text-background-50 font-semibold px-8 py-4 rounded-md whitespace-nowrap transition-colors cursor-pointer"
            >
              <i className="ri-whatsapp-line text-lg" />
              WhatsApp'tan Rezervasyon
            </a>
            <a
              href={`tel:${SITE.phoneTel}`}
              className="inline-flex items-center gap-2 bg-background-50/10 backdrop-blur-sm border border-background-50/40 text-background-50 font-semibold px-8 py-4 rounded-md whitespace-nowrap transition-colors hover:bg-background-50/20 cursor-pointer"
            >
              <i className="ri-phone-line text-lg" />
              {SITE.phoneDisplay}
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}